module.exports = __webpack_public_path__ + "media/mosaics/Mosaic-Testimonial-2-4cd6e01a.png";